module.exports = __webpack_public_path__ + "img/teacher-f4.76b8336e.png";